import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { ImpressumComponent } from './impressum.component';

const routes: Routes = [
    {path: '', component: ImpressumComponent}
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class ImpressumRoutingModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src?loader=system&genDir=src&aot=false!./~/tslint-loader!./src/app/impressum/impressum-routing.module.ts